import { createContext, useContext } from 'react';

type BalanceContextType = {
  balance: number;
  updateBalance: (balance: number) => void;
};

export const BalanceContext = createContext<BalanceContextType>({
  balance: 0,
  updateBalance: () => {}
});

export const useBalance = () => useContext(BalanceContext);
